import client from './SharedConfig';

export const getVehicleAdConfigs = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/vehicle/config/',
        headers: header
    };
    return client.request(config )
};

export const getStateConfigs = () => {
    const config = {
        method: 'GET',
        url: 'advertisement/states/list/'
    };
    return client.request(config )
};

export const getJobTypes = () => {
    const config = {
        method: 'GET',
        url: 'advertisement/job/types/list/'
    };
    return client.request(config)
};